
<template>
  <div
    :class="[appEnv != 'fgy' ? 'pro-select-wrapper' :'pro-select-wrapper1' ,{'pro-select-wrapper-folding': folding}]"
  >
    <div class="pro-select-contents">
      <a
        class="m-pro-ttip"
        @click="handleExpand"
        :class="{'m-pro-ttip-active': expanded}"
      >
        <span
          class="dot-ent-name1"
          v-show="!folding"
        >{{curProjectInfo&&curProjectInfo.name}}</span>
        <a-icon
          type="swap"
          v-show="projectList.length>1"
        />
        <!-- <a-icon
          type="caret-up"
          v-show="expanded && projectList.length>1"
        />
        <a-icon
          type="caret-down"
          v-show="!expanded && projectList.length>1"
        /> -->
      </a>
    </div>
    <div
      class="pro-drop-wrapper"
      :class="{'pro-drop-wrapper-folding': folding}"
      v-show="expanded"
      ref="entDropRef"
    >
      <div class="pro-search-header">
        <a-input-search
          placeholder="请搜索"
          class="ent-search"
          v-model="searchName"
          @search="fetchProject"
        />
      </div>
      <ul
        class="pro-list"
        v-if="projectList.length"
      >
        <li
          class="ent-m-item"
          :class="{'ent-m-item-active':currentSelectId==ent.id}"
          v-for="ent in projectList"
          :key="ent.id"
          @click="clickItem($event,ent)"
        >{{ent.name}}</li>
      </ul>
      <div
        class="no-project-data"
        v-else
      >
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { queryProjectList, accountSetLoginProject } from '@/api/projectTree'
import { setStore, getStore } from '@/utils/storage'
import { event } from "@ice/stark-data";
import { setLoginProject } from '@/utils/ent-pro.js'
export default {
  props: {
    showVisible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(['entInfo', 'isProjectShow', 'folding'])
  },
  watch: {
    showVisible (newV, oldV) {
      if (newV) {
        this.isSelect = true
        this.fetchProjectList()
      }
    },
    'entInfo.id': {
      handler (newV) {
        if (newV) {
          this.isSelect = true
          this.fetchProjectList()
        }
      },
      deep: true
    }
  },
  data () {
    return {
      searchName: '',
      projectList: [],
      isSelect: false,
      isInit: true,
      currentSelectId: '',
      expanded: false,
      curProjectInfo: null,
      projectDropRef: null,
      appEnv:'', //项目标识符
    }
  },
  mounted () {
    this.isSelect = true
    this.isInit = true
    this.initMEvent()
    this.$nextTick(() => {
      this.initDomEvent()
    })
    this.fetchProjectList()
    this.appEnv = process.env.VUE_APP_ENV
  },
  methods: {
    initDomEvent () {
      document.addEventListener('click', (e) => {
        if (this.$refs.entDropRef) {
          const isSelf = this.$refs.entDropRef.contains(e.target)
          if (!isSelf) {
            this.expanded = false
            this.$store.commit('SEARCH_PROJETC', false)
          }
        }
      })
    },
    initMEvent () {
      event.on('refreshProject', (item) => {
        if (item && item != "undefined") {
          setStore('projectInfo', JSON.stringify(item))
          this.currentSelectId = item.id
          this.curProjectInfo = item
          this.$emit('chooseProject', item, this.projectList)
          this.$emit("closeProjectSelect", false);
          this.$store.commit("SET_PROJECTINFO", item);
          this.$actions.setGlobalState({ projectInfo: item });
          this.searchName = ''
        } else {
          const mProjectInfo = {
            enterpriseId: null,
            id: null,
            industryId: null,
            keywords: null,
            level: null,
            name: null,
            parentId: null,
            type: null,
            grandPaId: null
          }
          this.projectList = []
          setStore('projectInfo', JSON.stringify(mProjectInfo))
          this.$store.commit("SET_PROJECTINFO", mProjectInfo);
          this.$actions.setGlobalState({
            projectInfo: mProjectInfo
          });
        }

      })
    },
    async fetchProjectList (isSearch) {
      if (this.entInfo.id) {
        const data = {
          enterpriseId: this.entInfo.id,
          keywords: this.searchName
        }
        try {
          const { code, result } = await queryProjectList(data)
          if (code === 1000) {
            if (Array.isArray(result) && result.length > 0) {
              this.projectList = result?.map((o) => {
                o.grandPaId = this.entInfo.organizationId
                o.projectId = o.id
                o.value = o.id
                o.label = o.name
                // o.grandPaId = this.entInfo.id
                o.enterpriseId = this.entInfo.id
                o.parentId = this.entInfo.organizationId
                return o
              }) || []
              console.log("this.projectList = ", this.projectList);
              if (this.projectList.length && this.isSelect && !isSearch) {
                const savedProjectInfo = JSON.parse(getStore('projectInfo'))
                if (savedProjectInfo && savedProjectInfo.id) {
                  this.curProjectInfo = savedProjectInfo
                  this.$emit(
                    "chooseProject",
                    savedProjectInfo,
                    this.projectList
                  );
                  this.currentSelectId = savedProjectInfo.id
                  this.$store.commit("SET_PROJECTINFO", savedProjectInfo);
                  this.$actions.setGlobalState({
                    projectInfo: savedProjectInfo
                  });
                } else {
                  // add by bb 20231017 判断是否有选定的项目，如果没有则默认为第一个项目
                  let selectedItems = false
                  for (let index = 0; index < this.projectList.length; index++) {
                    const element = this.projectList[index];
                    if (element && element.selectedItems) {
                        selectedItems = true
                        this.$emit(
                          "chooseProject",
                          element,
                          this.projectList
                        );
                        this.currentSelectId = element.id
                        this.curProjectInfo = element
                        setStore('projectInfo', JSON.stringify(element))
                        this.$store.commit("SET_PROJECTINFO", element);
                        this.$actions.setGlobalState({
                          projectInfo: element
                        });
                        break
                    }
                    
                  }
                  if (!selectedItems) {
                      this.$emit(
                        "chooseProject",
                        this.projectList[0],
                        this.projectList
                      );
                      this.currentSelectId = this.projectList[0].id
                      this.curProjectInfo = this.projectList[0]
                      setStore('projectInfo', JSON.stringify(this.projectList[0]))
                      // add by bb 20231018 保存项目
                      let accountDTO = {
                          defaultProject: this.projectList[0].id,//项目id
                          defaultEnterprise: this.projectList[0].enterpriseId //企业id
                      }
                      setLoginProject(accountDTO)
                      this.$store.commit("SET_PROJECTINFO", this.projectList[0]);
                      this.$actions.setGlobalState({
                        projectInfo: this.projectList[0]
                      });
                  }
                }
              }
            } else {
              const mProjectInfo = {
                enterpriseId: null,
                id: null,
                industryId: null,
                keywords: null,
                level: null,
                name: null,
                parentId: null,
                type: null,
                grandPaId: null
              }
              this.projectList = []
              setStore('projectInfo', JSON.stringify(mProjectInfo))
              this.$store.commit("SET_PROJECTINFO", mProjectInfo);
              this.$actions.setGlobalState({
                projectInfo: mProjectInfo
              });
            }
            if (this.isInit) {
              this.$store.commit("SET_PRODS", this.projectList);
            }
            if (isSearch) {
              this.expanded = true
              this.$store.commit('SEARCH_PROJETC', true)
            }
          }
        } catch (error) {

        }
      }

    },
    fetchProject () {
      this.fetchProjectList(true)
    },
    onChange () {
      this.isSelect = false
      this.isInit = false
      this.fetchProjectList()
    },
    handleCancel () {
      this.$emit("closeProjectSelect", false);
      this.searchName = ''
    },
    clickItem (event, item) {
      this.$store.commit('SEARCH_PROJETC', false)
      event.stopPropagation()
      this.currentSelectId = item.id
      setStore('projectInfo', JSON.stringify(item))
      // add by bb 20231018 保存项目
      let accountDTO = {
          defaultProject: item.id,//项目id
          defaultEnterprise: item.enterpriseId //企业id
      }
      setLoginProject(accountDTO)
      this.$emit('chooseProject', item, this.projectList)
      this.$emit("closeProjectSelect", false);
      this.$store.commit("SET_PROJECTINFO", item);
      this.$actions.setGlobalState({ projectInfo: item });
      this.searchName = item.name
      location.reload()
    },
    handleExpand (event) {
      event.stopPropagation()
      if (this.projectList.length > 1) {
        this.expanded = !this.expanded
      }
    },
  }
}
</script>
<style>
.m-custom-project-select {
  max-height: 300px;
  overflow-y: auto;
  width: 240px;
}
.mm-project-select {
  width: 200px;
}
.mm-project-select > div {
  background: transparent;
  border: none;
}
.mm-project-select > div > div > div {
  font-weight: 500;
  font-size: 16px;
}
</style>
<style lang="less" scoped>
.pro-list {
  list-style: none;
  width: 280px;
  box-sizing: border-box;
  li {
    padding: 5px 16px;
    height: 32px;
    color: #262626;
    font-size: 14px;
    margin-bottom: 8px;
    cursor: pointer;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}
.pro-search-header {
  width: 100%;
  padding: 12px 16px;
}
.no-project-data {
  height: 100px;
  width: 100%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}
.m-pro-ttip {
  font-weight: 500;
  font-size: 16px;
  line-height: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-around;
}
.dot-ent-name1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
.pro-select-contents {
  width: 100%;
  height: 56px;
  line-height: 56px;
}
.pro-drop-wrapper {
  position: absolute;
  z-index: 999999 !important;
  left: 18px;
  top: 66px;
  width: 280px;
  background: #ffffff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.12), 0px 4px 16px rgba(0, 0, 0, 0.08),
    0px 6px 28px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  max-height: 368px;
  overflow-y: auto;
}
.pro-drop-wrapper-folding {
  left: 52px;
  top: 0;
}
.pro-select-wrapper {
  position: fixed;
  width: 226px;
  padding-left: 16px;
  padding-right: 12px;
  left: 0;
  top: 56px;
  z-index: 8;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
  box-shadow: 13px 0 22px -12px rgba(0, 0, 0, 0.1);
}
.pro-select-wrapper1 {
  position: fixed;
}
.pro-select-wrapper-folding {
  width: 50px;
  padding: 0;
}
.entprise-select-search {
  width: 294px;
  margin-bottom: 16px;
}
.entprise-select-dialog {
  .business-modal-content {
    width: 750px;
  }
}
.entprise-select-list {
  margin-left: 0;
  padding-left: 0;
}
.entprise-select-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 8px;
  .entprise-select-name {
    flex: 1;
    color: #262626;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }
  .entprise-select-icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    background: url('~@/assets/images/common/ent-select-icon.png') no-repeat
      center;
    background-size: 100%;
    margin-right: 8px;
  }
}
</style>
